import axios from "axios";
import { USER_INFO_EMAIL, GET_ALL_BLOGS, SINGLE_BLOG_GET } from "./apiUrls";

export function userEmailSendApiFunc(Data) {
  return axios({
    method: "post",
    url: USER_INFO_EMAIL,
    data: Data,
  });
}

export function getBlogContentApi() {
  return axios({
    method: "get",
    url: GET_ALL_BLOGS,
  });
}

export function singleGetBlogContentApi(id) {
  return axios({
    method: "get",
    url: `${SINGLE_BLOG_GET}/${id}`,
  });
}
